module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("liSjt"))).then(() => parcelRequire('hEqeo'));